import { createAsyncThunk } from '@reduxjs/toolkit';
import assetServiceApiInstance from '../../../../config/assetApiConfig';

// Allocate Asset
export const allocateAsset = createAsyncThunk(
    'assetAllocation/allocate',
    async (data: any, { rejectWithValue }) => {
        try {
            const response = await assetServiceApiInstance.post('/asset-allocations', data);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to allocate asset');
        }
    }
);

// Update Allocation
export const updateAllocation = createAsyncThunk(
    'assetAllocation/update',
    async ({ allocationId, ...data }: any & { allocationId: number }, { rejectWithValue }) => {
        try {
            const response = await assetServiceApiInstance.put(`/asset-allocations/update/${allocationId}`, data);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to update asset allocation');
        }
    }
);


// Fetch All Asset Allocations
export const fetchAllAllocations = createAsyncThunk(
    'assetAllocation/fetchAll',
    async (_, { rejectWithValue }) => {
        try {
            const response = await assetServiceApiInstance.get('/asset-allocations');
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch asset allocations');
        }
    }
);

// Fetch Asset Allocation by ID
export const fetchAllocationById = createAsyncThunk(
    'assetAllocation/fetchById',
    async (allocationId: number, { rejectWithValue }) => {
        try {
            const response = await assetServiceApiInstance.get(`/asset-allocations/${allocationId}`);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch asset allocation');
        }
    }
);

// Update Allocation Status
export const updateAllocationStatus = createAsyncThunk(
    'assetAllocation/updateStatus',
    async ({ allocationId, ...data }: any & { allocationId: number }, { rejectWithValue }) => {
        try {
            const response = await assetServiceApiInstance.put(`/asset-allocations/${allocationId}/update-status`, data);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to update allocation status');
        }
    }
);

// Delete Asset Allocation
export const deleteAllocation = createAsyncThunk(
    'assetAllocation/delete',
    async (allocationId: number, { rejectWithValue }) => {
        try {
            const response = await assetServiceApiInstance.delete(`/asset-allocations/${allocationId}`);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to delete asset allocation');
        }
    },
);

export const fetchAllocatedAssetsByEmployeeId = createAsyncThunk(
  'assetAllocation/fetchAllocatedByEmployeeId',
  async (employeeId: number, { rejectWithValue }) => {
    try {
      const response = await assetServiceApiInstance.get(`/asset-allocations/allocated/${employeeId}`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to fetch allocated assets');
    }
  }
);
